import {
  SimpleObservableSubject,
  type WatchSubjectConfig,
  notifySubject as notifySubjectObservable,
} from "@/utils/observable";
import { watchEffect } from "vue";

export function useSimpleObservableSubject<T>() {
  const subject = new SimpleObservableSubject<T>();

  function watchSubject(
    watcher: (value: T) => void,
    config?: WatchSubjectConfig,
  ) {
    watchEffect((onCleanup) => {
      const unsubscribe = subject.subscribe(watcher, config);
      onCleanup(unsubscribe);
    });
  }

  function notifySubject(data: T) {
    notifySubjectObservable(subject, data);
  }

  return {
    watchSubject,
    notifySubject,
  };
}
